export default {
  setLoading(loading) {
    if (loading) {
      document.getElementsByTagName('body')[0].classList.add('loading');
    } else {
      document.getElementsByTagName('body')[0].classList.remove('loading');
    }
  }
};
